// @ts-nocheck so that typescript does not complain for the raw data
import type { CommerceToolProducts } from '@ecomm/data-simplisafe-api/parseProduct'
export const commerceToolProducts: readonly CommerceToolProducts[] = [
  {
    "@@type": "product",
    "hardwareVersion": "",
    "id": "SSSAPP-Y__11549",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSSAPP-Y__11549",
    "name": {
      "en-US": "Monitoring Service + Smart Alerts: 1 Year Prepaid (1 month free)",
      "en-GB": "Monitoring Service + Smart Alerts: 1 Year Prepaid (1 month free)"
    },
    "nodeId": 11549,
    "price": 252.89,
    "productTypeId": "e4a00ff7-f5f2-4efe-bd01-3237e4aec1c1",
    "restockDate": "",
    "sku": "SSSAPP-Y__11549",
    "variants": [],
    "productType": "service",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "0",
    "id": "SSYS3-FREE",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSYS3-FREE",
    "name": {
      "en-US": "Home Security Yard Sign",
      "en-GB": "Home Security Yard Sign"
    },
    "nodeId": 17600835,
    "price": 0,
    "productTypeId": "1bc8cbc7-1316-4082-b772-f2736926ff2f",
    "restockDate": "1970-01-01",
    "sku": "SSYS3-FREE",
    "variants": [],
    "productType": "accessory",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "SSPA3B",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSPA3B",
    "name": {
      "en-US": "Power Adapter",
      "en-GB": "Power Adapter"
    },
    "nodeId": 3143514,
    "price": 5,
    "productTypeId": "1bc8cbc7-1316-4082-b772-f2736926ff2f",
    "restockDate": "1970-01-01",
    "sku": "SSPA3B",
    "variants": [],
    "productType": "accessory",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "farmers-home-security-system-en-US",
    "isCartable": false,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": false,
    "isViewable": true,
    "masterSku": "farmers-home-security-system-en-US",
    "name": {
      "en-US": "Farmers Home Security System",
      "en-GB": "Farmers Home Security System"
    },
    "nodeId": 7755765,
    "price": 60,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "farmers-home-security-system-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "CM007-01DUS",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "CM007-01DUS",
    "name": {
      "en-US": "Smart Alarm Wireless Indoor Security Camera 7.5W Power Adapter",
      "en-GB": "Smart Alarm Wireless Indoor Security Camera 7.5W Power Adapter"
    },
    "nodeId": 13473695,
    "price": 9.99,
    "productTypeId": "1bc8cbc7-1316-4082-b772-f2736926ff2f",
    "restockDate": "1970-01-01",
    "sku": "CM007-01DUS",
    "variants": [],
    "productType": "accessory",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "oakstone-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "oakstone-en-US",
    "name": {
      "en-US": "Oakstone",
      "en-GB": "Oakstone"
    },
    "nodeId": 3487174,
    "price": 374.88,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "oakstone-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "",
    "id": "SSSAPP__5475172",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSSAPP__5475172",
    "name": {
      "en-US": "Standard Monitoring",
      "en-GB": "Standard Monitoring"
    },
    "nodeId": 5475172,
    "price": 22.99,
    "productTypeId": "e4a00ff7-f5f2-4efe-bd01-3237e4aec1c1",
    "restockDate": "",
    "sku": "SSSAPP__5475172",
    "variants": [],
    "productType": "service",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "SSPB3",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSPB3",
    "name": {
      "en-US": "Panic Button",
      "en-GB": "Panic Button"
    },
    "nodeId": 2198603,
    "price": 19.99,
    "productTypeId": "b7302816-bdaf-4b06-99fd-994f3622e8ca",
    "restockDate": "1970-01-01",
    "sku": "SSPB3",
    "variants": [],
    "productType": "sensor",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "knox-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "knox-en-US",
    "name": {
      "en-US": "Knox",
      "en-GB": "Knox"
    },
    "nodeId": 16544412,
    "price": 489.87,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "knox-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "0",
    "id": "SSMAG4",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSMAG4",
    "name": {
      "en-US": "Magnet for Entry Sensor",
      "en-GB": "Magnet for Entry Sensor"
    },
    "nodeId": 2758778,
    "price": 4.99,
    "productTypeId": "1bc8cbc7-1316-4082-b772-f2736926ff2f",
    "restockDate": "1970-01-01",
    "sku": "SSMAG4",
    "variants": [],
    "productType": "accessory",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "",
    "id": "SSEDSM2__195369",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSEDSM2__195369",
    "name": {
      "en-US": "24/7 Professional Alarm Monitoring - 30 Days Free!",
      "en-GB": "24/7 Professional Alarm Monitoring - 30 Days Free!"
    },
    "nodeId": 195369,
    "price": 32.99,
    "productTypeId": "e4a00ff7-f5f2-4efe-bd01-3237e4aec1c1",
    "restockDate": "",
    "sku": "SSEDSM2__195369",
    "variants": [],
    "productType": "service",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "CM006-01DWW",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "CM006-01DWW",
    "name": {
      "en-US": "Smart Alarm Wireless Indoor Security Camera",
      "en-GB": "Smart Alarm Wireless Indoor Security Camera"
    },
    "nodeId": 16489614,
    "price": 149.99,
    "productTypeId": "b7302816-bdaf-4b06-99fd-994f3622e8ca",
    "restockDate": "1970-01-01",
    "sku": "CM006-01DWW",
    "variants": [],
    "productType": "sensor",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "usaa-whole-home-kit-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "usaa-whole-home-kit-en-US",
    "name": {
      "en-US": "Usaa Whole Home Kit",
      "en-GB": "Usaa Whole Home Kit"
    },
    "nodeId": 17071209,
    "price": 849.96,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "usaa-whole-home-kit-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "oakhaven-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "oakhaven-en-US",
    "name": {
      "en-US": "Oakhaven",
      "en-GB": "Oakhaven"
    },
    "nodeId": 3333590,
    "price": 499,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "oakhaven-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "wirecutter-essentials-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "wirecutter-essentials-en-US",
    "name": {
      "en-US": "Wirecutter Essentials "
    },
    "nodeId": 7166658,
    "price": 259.95,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "wirecutter-essentials-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "corporate-kit-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "corporate-kit-en-US",
    "name": {
      "en-US": "Corporate Kit",
      "en-GB": "Corporate Kit"
    },
    "nodeId": 7134574,
    "price": 393.89,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "corporate-kit-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "2",
    "id": "SSES1",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSES1",
    "name": {
      "en-US": "Entry Sensor",
      "en-GB": "Entry Sensor"
    },
    "nodeId": 18858579,
    "price": 15.99,
    "productTypeId": "b7302816-bdaf-4b06-99fd-994f3622e8ca",
    "restockDate": "1970-01-01",
    "sku": "SSES1",
    "variants": [],
    "productType": "sensor",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "",
    "id": "SSSAPP__4867402",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSSAPP__4867402",
    "name": {
      "en-US": "Standard Monitoring - 30 Days Free",
      "en-GB": "Standard Monitoring - 30 Days Free"
    },
    "nodeId": 4867402,
    "price": 22.99,
    "productTypeId": "e4a00ff7-f5f2-4efe-bd01-3237e4aec1c1",
    "restockDate": "",
    "sku": "SSSAPP__4867402",
    "variants": [],
    "productType": "service",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "",
    "id": "SSSAPP__1964932",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSSAPP__1964932",
    "name": {
      "en-US": "24/7 Professional Alarm Monitoring Non-Interactive",
      "en-GB": "24/7 Professional Alarm Monitoring Non-Interactive"
    },
    "nodeId": 1964932,
    "price": 22.99,
    "productTypeId": "e4a00ff7-f5f2-4efe-bd01-3237e4aec1c1",
    "restockDate": "",
    "sku": "SSSAPP__1964932",
    "variants": [],
    "productType": "service",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "0",
    "id": "SSWD1",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSWD1",
    "name": {
      "en-US": "Window Decal",
      "en-GB": "Window Decal"
    },
    "nodeId": 5345,
    "price": 1,
    "productTypeId": "1bc8cbc7-1316-4082-b772-f2736926ff2f",
    "restockDate": "1970-01-01",
    "sku": "SSWD1",
    "variants": [],
    "productType": "accessory",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "0",
    "id": "CA010-02DUS",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "CA010-02DUS",
    "name": {
      "en-US": "Smart Lock Series 2 - Black",
      "en-GB": "Smart Lock Series 2 - Black"
    },
    "nodeId": 16862545,
    "price": 119.99,
    "productTypeId": "b7302816-bdaf-4b06-99fd-994f3622e8ca",
    "restockDate": "1970-01-01",
    "sku": "CA010-02DUS",
    "variants": [],
    "productType": "sensor",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "CM009-02DWW",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "CM009-02DWW",
    "name": {
      "en-GB": "Permanent Mount for Outdoor Camera",
      "en-US": "Permanent Mount for Outdoor Camera"
    },
    "nodeId": 11423762,
    "price": 14.99,
    "productTypeId": "1bc8cbc7-1316-4082-b772-f2736926ff2f",
    "restockDate": "1970-01-01",
    "sku": "CM009-02DWW",
    "variants": [],
    "productType": "accessory",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "starter-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "starter-en-US",
    "name": {
      "en-US": "Starter",
      "en-GB": "Starter"
    },
    "nodeId": 16601162,
    "price": 279.95,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "starter-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "0",
    "id": "CA010-01DUS",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "CA010-01DUS",
    "name": {
      "en-US": "Smart Lock Series 2 - White",
      "en-GB": "Smart Lock Series 2 - White"
    },
    "nodeId": 16862541,
    "price": 119.99,
    "productTypeId": "b7302816-bdaf-4b06-99fd-994f3622e8ca",
    "restockDate": "1970-01-01",
    "sku": "CA010-01DUS",
    "variants": [],
    "productType": "sensor",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "stonefort-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "stonefort-en-US",
    "name": {
      "en-US": "Stonefort",
      "en-GB": "Stonefort"
    },
    "nodeId": 3487292,
    "price": 499.84,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "stonefort-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "CMOB1-INC",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "CMOB1-INC",
    "name": {
      "en-US": "Outdoor Security Camera",
      "en-GB": "Outdoor Security Camera"
    },
    "nodeId": 16496391,
    "price": 199.99,
    "productTypeId": "b7302816-bdaf-4b06-99fd-994f3622e8ca",
    "restockDate": "1970-01-01",
    "sku": "CMOB1-INC",
    "variants": [],
    "productType": "sensor",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "SSES3",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSES3",
    "name": {
      "en-US": "Entry Sensor",
      "en-GB": "Entry Sensor"
    },
    "nodeId": 18843476,
    "price": 15.99,
    "productTypeId": "b7302816-bdaf-4b06-99fd-994f3622e8ca",
    "restockDate": "1970-01-01",
    "sku": "SSES3",
    "variants": [],
    "productType": "sensor",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "",
    "id": "SSSAPP-SMB-Y__18994629",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSSAPP-SMB-Y__18994629",
    "name": {
      "en-US": "SMB Standard (Yearly)",
      "en-GB": "SMB Standard (Yearly)"
    },
    "nodeId": 18994629,
    "price": 241.89,
    "productTypeId": "e4a00ff7-f5f2-4efe-bd01-3237e4aec1c1",
    "restockDate": "",
    "sku": "SSSAPP-SMB-Y__18994629",
    "variants": [],
    "productType": "service",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "",
    "id": "SSODMON247-SMB__18994702",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSODMON247-SMB__18994702",
    "name": {
      "en-US": "SMB Pro Plus Business (Monthly)",
      "en-GB": "SMB Pro Plus Business (Monthly)"
    },
    "nodeId": 18994702,
    "price": 79.99,
    "productTypeId": "e4a00ff7-f5f2-4efe-bd01-3237e4aec1c1",
    "restockDate": "",
    "sku": "SSODMON247-SMB__18994702",
    "variants": [],
    "productType": "service",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "barrington-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "barrington-en-US",
    "name": {
      "en-US": "Barrington",
      "en-GB": "Barrington"
    },
    "nodeId": 7405101,
    "price": 388.93,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "barrington-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "closing-gift-kit-en-US",
    "isCartable": false,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": false,
    "isViewable": true,
    "masterSku": "closing-gift-kit-en-US",
    "name": {
      "en-US": "Closing Gift Kit",
      "en-GB": "Closing Gift Kit"
    },
    "nodeId": 7405205,
    "price": 369,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "closing-gift-kit-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "SSFS3",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSFS3",
    "name": {
      "en-US": "Temperature Sensor",
      "en-GB": "Temperature Sensor"
    },
    "nodeId": 2198572,
    "price": 29.99,
    "productTypeId": "b7302816-bdaf-4b06-99fd-994f3622e8ca",
    "restockDate": "1970-01-01",
    "sku": "SSFS3",
    "variants": [],
    "productType": "sensor",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "0",
    "id": "SSDB3-INC",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSDB3-INC",
    "name": {
      "en-US": "Wired Video Doorbell",
      "en-GB": "Wired Video Doorbell"
    },
    "nodeId": 18088289,
    "price": 169,
    "productTypeId": "b7302816-bdaf-4b06-99fd-994f3622e8ca",
    "restockDate": "1970-01-01",
    "sku": "SSDB3-INC",
    "variants": [],
    "productType": "sensor",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "0",
    "id": "SSOKB",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSOKB",
    "name": {
      "en-US": "SimpliCam Outdoor Kit",
      "en-GB": "SimpliCam Outdoor Kit"
    },
    "nodeId": 4204580,
    "price": 19.99,
    "productTypeId": "1bc8cbc7-1316-4082-b772-f2736926ff2f",
    "restockDate": "1970-01-01",
    "sku": "SSOKB",
    "variants": [],
    "productType": "accessory",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "CA011-01DUS",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "CA011-01DUS",
    "name": {
      "en-US": "Smoke & Carbon Monoxide Alarm Listener",
      "en-GB": "Smoke & Carbon Monoxide Alarm Listener"
    },
    "nodeId": 19216891,
    "price": 44.99,
    "productTypeId": "b7302816-bdaf-4b06-99fd-994f3622e8ca",
    "restockDate": "1970-01-01",
    "sku": "CA011-01DUS",
    "variants": [],
    "productType": "sensor",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "SSWT3-INC",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSWT3-INC",
    "name": {
      "en-US": "Water Sensor",
      "en-GB": "Water Sensor"
    },
    "nodeId": 16504941,
    "price": 19.99,
    "productTypeId": "b7302816-bdaf-4b06-99fd-994f3622e8ca",
    "restockDate": "1970-01-01",
    "sku": "SSWT3-INC",
    "variants": [],
    "productType": "sensor",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "0",
    "id": "SSPSH-ON",
    "isCartable": true,
    "isIndeterminatePrice": true,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSPSH-ON",
    "name": {
      "en-US": "Professional Installation (billed separately)",
      "en-GB": "Professional Installation (billed separately)"
    },
    "nodeId": 8614809,
    "price": 0,
    "productTypeId": "1bc8cbc7-1316-4082-b772-f2736926ff2f",
    "restockDate": "1970-01-01",
    "sku": "SSPSH-ON",
    "variants": [],
    "productType": "accessory",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "the-wirecutter-essentials-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "the-wirecutter-essentials-en-US",
    "name": {
      "en-US": "The Wirecutter Essentials ",
      "en-GB": "The Wirecutter Essentials "
    },
    "nodeId": 7166658,
    "price": 259.95,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "the-wirecutter-essentials-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "",
    "id": "SSEDSM2__5093346",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSEDSM2__5093346",
    "name": {
      "en-US": "Core Monitoring - 60 Days Free!",
      "en-GB": "Core Monitoring - 60 Days Free!"
    },
    "nodeId": 5093346,
    "price": 32.99,
    "productTypeId": "e4a00ff7-f5f2-4efe-bd01-3237e4aec1c1",
    "restockDate": "",
    "sku": "SSEDSM2__5093346",
    "variants": [],
    "productType": "service",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "CM001",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "CM001",
    "name": {
      "en-GB": "Solar Panel Outdoor Charger",
      "en-US": "Solar Panel Outdoor Charger"
    },
    "nodeId": 8351121,
    "price": 79.99,
    "productTypeId": "1bc8cbc7-1316-4082-b772-f2736926ff2f",
    "restockDate": "1970-01-01",
    "sku": "CM001",
    "variants": [],
    "productType": "accessory",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "",
    "id": "SSEDSM2__5160116",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSEDSM2__5160116",
    "name": {
      "en-US": "Interactive Alarm Monitoring - 6 Months",
      "en-GB": "Interactive Alarm Monitoring - 6 Months"
    },
    "nodeId": 5160116,
    "price": 32.99,
    "productTypeId": "e4a00ff7-f5f2-4efe-bd01-3237e4aec1c1",
    "restockDate": "",
    "sku": "SSEDSM2__5160116",
    "variants": [],
    "productType": "service",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "SSCO3",
    "isCartable": false,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": false,
    "isViewable": true,
    "masterSku": "SSCO3",
    "name": {
      "en-GB": "Carbon Monoxide Detector",
      "en-US": "Carbon Monoxide Detector"
    },
    "nodeId": 2198616,
    "price": 49.99,
    "productTypeId": "b7302816-bdaf-4b06-99fd-994f3622e8ca",
    "restockDate": "1970-01-01",
    "sku": "SSCO3",
    "variants": [],
    "productType": "sensor",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "restaurant-protection-kit-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "restaurant-protection-kit-en-US",
    "name": {
      "en-US": "Restaurant Protection Kit",
      "en-GB": "Restaurant Protection Kit"
    },
    "nodeId": 7136592,
    "price": 488.85,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "restaurant-protection-kit-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "SSSB-2INCAM-INC",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": false,
    "masterSku": "SSSB-2INCAM-INC",
    "name": {
      "en-US": "Wired Indoor Camera 2 Pack",
      "en-GB": "Wired Indoor Camera 2 Pack"
    },
    "nodeId": 17843385,
    "price": 198,
    "productTypeId": "b7302816-bdaf-4b06-99fd-994f3622e8ca",
    "restockDate": "1970-01-01",
    "sku": "SSSB-2INCAM-INC",
    "variants": [],
    "productType": "sensor",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "0",
    "id": "LT021",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": false,
    "masterSku": "LT021",
    "name": {
      "en-US": "Outdoor Camera Accessory Guide",
      "en-GB": "Outdoor Camera Accessory Guide"
    },
    "nodeId": 14641601,
    "price": 0,
    "productTypeId": "1bc8cbc7-1316-4082-b772-f2736926ff2f",
    "restockDate": "1970-01-01",
    "sku": "LT021",
    "variants": [],
    "productType": "accessory",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "",
    "id": "SSEDSM2-SMB-Y__18994676",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSEDSM2-SMB-Y__18994676",
    "name": {
      "en-US": "Core Business (Yearly)",
      "en-GB": "Core Business (Yearly)"
    },
    "nodeId": 18994676,
    "price": 351.89,
    "productTypeId": "e4a00ff7-f5f2-4efe-bd01-3237e4aec1c1",
    "restockDate": "",
    "sku": "SSEDSM2-SMB-Y__18994676",
    "variants": [],
    "productType": "service",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "foundation-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "foundation-en-US",
    "name": {
      "en-US": "Foundation",
      "en-GB": "Foundation"
    },
    "nodeId": 13020858,
    "price": 249.96,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "foundation-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "SSSB-SSKF3B",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSSB-SSKF3B",
    "name": {
      "en-GB": "Two Key Fobs Bundle",
      "en-US": "Two Key Fobs Bundle"
    },
    "nodeId": 11928433,
    "price": 49.98,
    "productTypeId": "b7302816-bdaf-4b06-99fd-994f3622e8ca",
    "restockDate": "1970-01-01",
    "sku": "SSSB-SSKF3B",
    "variants": [],
    "productType": "sensor",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "",
    "id": "SSSLFCAM__7711192",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSSLFCAM__7711192",
    "name": {
      "en-US": "Self Monitoring with Camera Recordings",
      "en-GB": "Self Monitoring with Camera Recordings"
    },
    "nodeId": 7711192,
    "price": 9.99,
    "productTypeId": "e4a00ff7-f5f2-4efe-bd01-3237e4aec1c1",
    "restockDate": "",
    "sku": "SSSLFCAM__7711192",
    "variants": [],
    "productType": "service",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "sscs3-pla-13053393-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "sscs3-pla-13053393-en-US",
    "name": {
      "en-US": "SimpliSafe Home Security System: 11 pieces",
      "en-GB": "SimpliSafe Home Security System: 11 pieces"
    },
    "nodeId": 13053393,
    "price": 399.9,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "sscs3-pla-13053393-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "0",
    "id": "SSCM2",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSCM2",
    "name": {
      "en-US": "Wired Indoor Camera",
      "en-GB": "Wired Indoor Camera"
    },
    "nodeId": 7133170,
    "price": 99,
    "productTypeId": "1bc8cbc7-1316-4082-b772-f2736926ff2f",
    "restockDate": "1970-01-01",
    "sku": "SSCM2",
    "variants": [],
    "productType": "accessory",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "sscs3-pla-13053184-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "sscs3-pla-13053184-en-US",
    "name": {
      "en-US": "SimpliSafe Home Security System: 10 pieces",
      "en-GB": "SimpliSafe Home Security System: 10 pieces"
    },
    "nodeId": 13053184,
    "price": 408.92,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "sscs3-pla-13053184-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "sscs3-pla-13055494-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "sscs3-pla-13055494-en-US",
    "name": {
      "en-US": "SimpliSafe Home Security System: 6 pieces",
      "en-GB": "SimpliSafe Home Security System: 6 pieces"
    },
    "nodeId": 13055494,
    "price": 294.94,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "sscs3-pla-13055494-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "SSWS3-INC",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSWS3-INC",
    "name": {
      "en-GB": "Wireless Siren",
      "en-US": "Wireless Siren"
    },
    "nodeId": 11928998,
    "price": 59.99,
    "productTypeId": "b7302816-bdaf-4b06-99fd-994f3622e8ca",
    "restockDate": "1970-01-01",
    "sku": "SSWS3-INC",
    "variants": [],
    "productType": "sensor",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "small-non-insurance-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "small-non-insurance-en-US",
    "name": {
      "en-US": "Starter Kit - N",
      "en-GB": "Starter Kit - N"
    },
    "nodeId": 16546094,
    "price": 439.39,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "small-non-insurance-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "small-insurance-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "small-insurance-en-US",
    "name": {
      "en-US": "Starter Kit - I",
      "en-GB": "Starter Kit - I"
    },
    "nodeId": 16544995,
    "price": 434.93,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "small-insurance-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "storefront-system-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "storefront-system-en-US",
    "name": {
      "en-US": "Storefront System",
      "en-GB": "Storefront System"
    },
    "nodeId": 13041656,
    "price": 463.88,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "storefront-system-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "SSKP3W",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSKP3W",
    "name": {
      "en-US": "Keypad",
      "en-GB": "Keypad"
    },
    "nodeId": 2639216,
    "price": 69.99,
    "productTypeId": "b7302816-bdaf-4b06-99fd-994f3622e8ca",
    "restockDate": "1970-01-01",
    "sku": "SSKP3W",
    "variants": [],
    "productType": "sensor",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "sscs3-pla-13053141-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "sscs3-pla-13053141-en-US",
    "name": {
      "en-US": "SimpliSafe Home Security System: 10 pieces",
      "en-GB": "SimpliSafe Home Security System: 10 pieces"
    },
    "nodeId": 13053141,
    "price": 483.92,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "sscs3-pla-13053141-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "CA001-01DWW",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "CA001-01DWW",
    "name": {
      "en-GB": "Motion Sensor Gen 2",
      "en-US": "Motion Sensor Gen 2"
    },
    "nodeId": 12729289,
    "price": 34.99,
    "productTypeId": "1bc8cbc7-1316-4082-b772-f2736926ff2f",
    "restockDate": "1970-01-01",
    "sku": "CA001-01DWW",
    "variants": [],
    "productType": "accessory",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "0",
    "id": "MI037-INC",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "MI037-INC",
    "name": {
      "en-US": "Outdoor Camera Power Cable",
      "en-GB": "Outdoor Camera Power Cable"
    },
    "nodeId": 18913504,
    "price": 29.99,
    "productTypeId": "1bc8cbc7-1316-4082-b772-f2736926ff2f",
    "restockDate": "1970-01-01",
    "sku": "MI037-INC",
    "variants": [],
    "productType": "accessory",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "sscs3-pla-13053450-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "sscs3-pla-13053450-en-US",
    "name": {
      "en-US": "SimpliSafe Home Security System: 12 pieces",
      "en-GB": "SimpliSafe Home Security System: 12 pieces"
    },
    "nodeId": 13053450,
    "price": 483.9,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "sscs3-pla-13053450-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "0",
    "id": "SSYS3-INC",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSYS3-INC",
    "name": {
      "en-US": "Yard Sign",
      "en-GB": "Yard Sign"
    },
    "nodeId": 17600835,
    "price": 0,
    "productTypeId": "1bc8cbc7-1316-4082-b772-f2736926ff2f",
    "restockDate": "1970-01-01",
    "sku": "SSYS3-INC",
    "variants": [],
    "productType": "accessory",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "",
    "id": "SSEDSM2__16247908",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSEDSM2__16247908",
    "name": {
      "en-US": "Core Monitoring - 3 Months Free!",
      "en-GB": "Core Monitoring - 3 Months Free!"
    },
    "nodeId": 16247908,
    "price": 32.99,
    "productTypeId": "e4a00ff7-f5f2-4efe-bd01-3237e4aec1c1",
    "restockDate": "",
    "sku": "SSEDSM2__16247908",
    "variants": [],
    "productType": "service",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "CA002-01DWW",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "CA002-01DWW",
    "name": {
      "en-US": "Smoke & CO Detector",
      "en-GB": "Smoke & CO Detector"
    },
    "nodeId": 16489308,
    "price": 69.99,
    "productTypeId": "b7302816-bdaf-4b06-99fd-994f3622e8ca",
    "restockDate": "1970-01-01",
    "sku": "CA002-01DWW",
    "variants": [],
    "productType": "sensor",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "closing-gift-kit-1-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "closing-gift-kit-1-en-US",
    "name": {
      "en-US": "Closing Gift Kit",
      "en-GB": "Closing Gift Kit"
    },
    "nodeId": 13024224,
    "price": 374,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "closing-gift-kit-1-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "hub-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "hub-en-US",
    "name": {
      "en-US": "Hub",
      "en-GB": "Hub"
    },
    "nodeId": 8597249,
    "price": 622.97,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "hub-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "SSKF3B",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSKF3B",
    "name": {
      "en-US": "Keyfob",
      "en-GB": "Keyfob"
    },
    "nodeId": 2198577,
    "price": 24.99,
    "productTypeId": "b7302816-bdaf-4b06-99fd-994f3622e8ca",
    "restockDate": "1970-01-01",
    "sku": "SSKF3B",
    "variants": [],
    "productType": "sensor",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "lifelock-outdoor-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "lifelock-outdoor-en-US",
    "name": {
      "en-US": "Lifelock Outdoor",
      "en-GB": "Lifelock Outdoor"
    },
    "nodeId": 16546188,
    "price": 499.93,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "lifelock-outdoor-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "2",
    "id": "SSMS1",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSMS1",
    "name": {
      "en-US": "Motion Sensor",
      "en-GB": "Motion Sensor"
    },
    "nodeId": 299,
    "price": 29.99,
    "productTypeId": "b7302816-bdaf-4b06-99fd-994f3622e8ca",
    "restockDate": "1970-01-01",
    "sku": "SSMS1",
    "variants": [],
    "productType": "sensor",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "2",
    "id": "SSKR2",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSKR2",
    "name": {
      "en-US": "Keychain Remote",
      "en-GB": "Keychain Remote"
    },
    "nodeId": 309,
    "price": 24.99,
    "productTypeId": "b7302816-bdaf-4b06-99fd-994f3622e8ca",
    "restockDate": "1970-01-01",
    "sku": "SSKR2",
    "variants": [],
    "productType": "sensor",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "stronghold-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "stronghold-en-US",
    "name": {
      "en-US": "Stronghold",
      "en-GB": "Stronghold"
    },
    "nodeId": 3487226,
    "price": 439.87,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "stronghold-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "usaa-outdoor-kit-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "usaa-outdoor-kit-en-US",
    "name": {
      "en-US": "Usaa Outdoor Kit",
      "en-GB": "Usaa Outdoor Kit"
    },
    "nodeId": 18152647,
    "price": 629.94,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "usaa-outdoor-kit-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "CM021-01DWW-INC",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "CM021-01DWW-INC",
    "name": {
      "en-US": "Outdoor Security Camera Series 2",
      "en-GB": "Outdoor Security Camera Series 2"
    },
    "nodeId": 17283093,
    "price": 199.99,
    "productTypeId": "b7302816-bdaf-4b06-99fd-994f3622e8ca",
    "restockDate": "1970-01-01",
    "sku": "CM021-01DWW-INC",
    "variants": [],
    "productType": "sensor",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "usaa-package-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "usaa-package-en-US",
    "name": {
      "en-US": "USAA Package",
      "en-GB": "USAA Package"
    },
    "nodeId": 13037850,
    "price": 702,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "usaa-package-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "",
    "id": "SSSLFCAM__7711196",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSSLFCAM__7711196",
    "name": {
      "en-US": "Self Monitoring with Camera Recording - 2 Months Free",
      "en-GB": "Self Monitoring with Camera Recording - 2 Months Free"
    },
    "nodeId": 7711196,
    "price": 9.99,
    "productTypeId": "e4a00ff7-f5f2-4efe-bd01-3237e4aec1c1",
    "restockDate": "",
    "sku": "SSSLFCAM__7711196",
    "variants": [],
    "productType": "service",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "store-protection-system-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "store-protection-system-en-US",
    "name": {
      "en-US": "Store Protection System",
      "en-GB": "Store Protection System"
    },
    "nodeId": 13044776,
    "price": 472.87,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "store-protection-system-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "sscs3-pla-13053034-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "sscs3-pla-13053034-en-US",
    "name": {
      "en-US": "SimpliSafe Home Security System: 8 pieces",
      "en-GB": "SimpliSafe Home Security System: 8 pieces"
    },
    "nodeId": 13053034,
    "price": 314.93,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "sscs3-pla-13053034-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "citadel-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "citadel-en-US",
    "name": {
      "en-US": "Citadel",
      "en-GB": "Citadel"
    },
    "nodeId": 8597603,
    "price": 659.85,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "citadel-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "sscs3-pla-13053233-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "sscs3-pla-13053233-en-US",
    "name": {
      "en-US": "SimpliSafe Home Security System: 10 pieces",
      "en-GB": "SimpliSafe Home Security System: 10 pieces"
    },
    "nodeId": 13053233,
    "price": 399.91,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "sscs3-pla-13053233-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "sscs3-pla-13053299-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "sscs3-pla-13053299-en-US",
    "name": {
      "en-US": "SimpliSafe Home Security System: 11 pieces",
      "en-GB": "SimpliSafe Home Security System: 11 pieces"
    },
    "nodeId": 13053299,
    "price": 448.9,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "sscs3-pla-13053299-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "0",
    "id": "SSDBFP-CLASSIC",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": false,
    "masterSku": "SSDBFP-CLASSIC",
    "name": {
      "en-US": "Classic Doorbell Faceplate",
      "en-GB": "Classic Doorbell Faceplate"
    },
    "nodeId": 6213160,
    "price": 0,
    "productTypeId": "1bc8cbc7-1316-4082-b772-f2736926ff2f",
    "restockDate": "1970-01-01",
    "sku": "SSDBFP-CLASSIC",
    "variants": [],
    "productType": "accessory",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "lifelock-indoor-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "lifelock-indoor-en-US",
    "name": {
      "en-US": "Lifelock Indoor",
      "en-GB": "Lifelock Indoor"
    },
    "nodeId": 16546159,
    "price": 449.93,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "lifelock-indoor-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "0",
    "id": "SSATS3-3M-SMALL",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSATS3-3M-SMALL",
    "name": {
      "en-US": "3M - Adhesive Tape for Sensors (6 Pieces)",
      "en-GB": "3M - Adhesive Tape for Sensors (6 Pieces)"
    },
    "nodeId": 7979014,
    "price": 3.99,
    "productTypeId": "1bc8cbc7-1316-4082-b772-f2736926ff2f",
    "restockDate": "1970-01-01",
    "sku": "SSATS3-3M-SMALL",
    "variants": [],
    "productType": "accessory",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "store-protection-kit-8-pieces-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "store-protection-kit-8-pieces-en-US",
    "name": {
      "en-US": "Store Protection Kit: 8 Pieces",
      "en-GB": "Store Protection Kit: 8 Pieces"
    },
    "nodeId": 7136532,
    "price": 433.88,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "store-protection-kit-8-pieces-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "CMCBL1",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "CMCBL1",
    "name": {
      "en-GB": "Outdoor Camera Power Cable",
      "en-US": "Outdoor Camera Power Cable"
    },
    "nodeId": 10584497,
    "price": 29.99,
    "productTypeId": "1bc8cbc7-1316-4082-b772-f2736926ff2f",
    "restockDate": "1970-01-01",
    "sku": "CMCBL1",
    "variants": [],
    "productType": "accessory",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "sscs3-pla-13053113-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "sscs3-pla-13053113-en-US",
    "name": {
      "en-US": "SimpliSafe Home Security System: 10 pieces",
      "en-GB": "SimpliSafe Home Security System: 10 pieces"
    },
    "nodeId": 13053113,
    "price": 439.9,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "sscs3-pla-13053113-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "sscs3-pla-13053597-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "sscs3-pla-13053597-en-US",
    "name": {
      "en-US": "SimpliSafe Home Security System: 13 pieces",
      "en-GB": "SimpliSafe Home Security System: 13 pieces"
    },
    "nodeId": 13053597,
    "price": 453.89,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "sscs3-pla-13053597-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "sscs3-pla-13053487-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "sscs3-pla-13053487-en-US",
    "name": {
      "en-US": "SimpliSafe Home Security System: 12 pieces",
      "en-GB": "SimpliSafe Home Security System: 12 pieces"
    },
    "nodeId": 13053487,
    "price": 474.89,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "sscs3-pla-13053487-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "sscs3-pla-13055456-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "sscs3-pla-13055456-en-US",
    "name": {
      "en-US": "SimpliSafe Home Security System: 5 pieces",
      "en-GB": "SimpliSafe Home Security System: 5 pieces"
    },
    "nodeId": 13055456,
    "price": 249.98,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "sscs3-pla-13055456-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "0",
    "id": "LT006",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": false,
    "masterSku": "LT006",
    "name": {
      "en-US": "BSR Guide UK",
      "en-GB": "BSR Guide UK"
    },
    "nodeId": 11822556,
    "price": 0,
    "productTypeId": "1bc8cbc7-1316-4082-b772-f2736926ff2f",
    "restockDate": "1970-01-01",
    "sku": "LT006",
    "variants": [],
    "productType": "accessory",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "",
    "id": "SSSAPP__5093364",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSSAPP__5093364",
    "name": {
      "en-US": "Standard Monitoring - 60 Days Free",
      "en-GB": "Standard Monitoring - 60 Days Free"
    },
    "nodeId": 5093364,
    "price": 22.99,
    "productTypeId": "e4a00ff7-f5f2-4efe-bd01-3237e4aec1c1",
    "restockDate": "",
    "sku": "SSSAPP__5093364",
    "variants": [],
    "productType": "service",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "total-protection-system-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "total-protection-system-en-US",
    "name": {
      "en-US": "Total Protection System",
      "en-GB": "Total Protection System"
    },
    "nodeId": 6618346,
    "price": 398.92,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "total-protection-system-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "sscs3-pla-13053785-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "sscs3-pla-13053785-en-US",
    "name": {
      "en-US": "SimpliSafe Home Security System: 15 pieces",
      "en-GB": "SimpliSafe Home Security System: 15 pieces"
    },
    "nodeId": 13053785,
    "price": 399.86,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "sscs3-pla-13053785-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "0",
    "id": "SSMP2",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSMP2",
    "name": {
      "en-US": "Mover's Kit",
      "en-GB": "Mover's Kit"
    },
    "nodeId": 12864190,
    "price": 0,
    "productTypeId": "1bc8cbc7-1316-4082-b772-f2736926ff2f",
    "restockDate": "1970-01-01",
    "sku": "SSMP2",
    "variants": [],
    "productType": "accessory",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "smart-home-staging-kit-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "smart-home-staging-kit-en-US",
    "name": {
      "en-US": "Smart Home Staging Kit",
      "en-GB": "Smart Home Staging Kit"
    },
    "nodeId": 13047713,
    "price": 813,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "smart-home-staging-kit-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "sscs3-pla-13055633-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "sscs3-pla-13055633-en-US",
    "name": {
      "en-US": "SimpliSafe Home Security System: 7 pieces",
      "en-GB": "SimpliSafe Home Security System: 7 pieces"
    },
    "nodeId": 13055633,
    "price": 299.94,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "sscs3-pla-13055633-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "sscs3-pla-13055523-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "sscs3-pla-13055523-en-US",
    "name": {
      "en-US": "SimpliSafe Home Security System: 6 pieces",
      "en-GB": "SimpliSafe Home Security System: 6 pieces"
    },
    "nodeId": 13055523,
    "price": 264.95,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "sscs3-pla-13055523-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "sscs3-pla-13053268-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "sscs3-pla-13053268-en-US",
    "name": {
      "en-US": "SimpliSafe Home Security System: 10 pieces",
      "en-GB": "SimpliSafe Home Security System: 10 pieces"
    },
    "nodeId": 13053268,
    "price": 364.91,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "sscs3-pla-13053268-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "",
    "id": "SSSAPP__4873508",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSSAPP__4873508",
    "name": {
      "en-US": "Standard Monitoring",
      "en-GB": "Standard Monitoring"
    },
    "nodeId": 4873508,
    "price": 22.99,
    "productTypeId": "e4a00ff7-f5f2-4efe-bd01-3237e4aec1c1",
    "restockDate": "",
    "sku": "SSSAPP__4873508",
    "variants": [],
    "productType": "service",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "summerfor-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "summerfor-en-US",
    "name": {
      "en-US": "Summerfor",
      "en-GB": "Summerfor"
    },
    "nodeId": 3780402,
    "price": 713,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "summerfor-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "independent-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "independent-en-US",
    "name": {
      "en-US": "Independent",
      "en-GB": "Independent"
    },
    "nodeId": 3670756,
    "price": 718,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "independent-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "",
    "id": "SSSAPP__5160136",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSSAPP__5160136",
    "name": {
      "en-US": "Standard Monitoring - 6 Months",
      "en-GB": "Standard Monitoring - 6 Months"
    },
    "nodeId": 5160136,
    "price": 22.99,
    "productTypeId": "e4a00ff7-f5f2-4efe-bd01-3237e4aec1c1",
    "restockDate": "",
    "sku": "SSSAPP__5160136",
    "variants": [],
    "productType": "service",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "0",
    "id": "SSSOC-D2D",
    "isCartable": true,
    "isIndeterminatePrice": true,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSSOC-D2D",
    "name": {
      "en-US": "SimpliSafe Instant Delivery (Kit + Free Outdoor Camera)",
      "en-GB": "SimpliSafe Instant Delivery (Kit + Free Outdoor Camera)"
    },
    "nodeId": 19046350,
    "price": 0,
    "productTypeId": "1bc8cbc7-1316-4082-b772-f2736926ff2f",
    "restockDate": "1970-01-01",
    "sku": "SSSOC-D2D",
    "variants": [],
    "productType": "accessory",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "sscs3-pla-13052785-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "sscs3-pla-13052785-en-US",
    "name": {
      "en-US": "SimpliSafe Home Security System: 9 pieces",
      "en-GB": "SimpliSafe Home Security System: 9 pieces"
    },
    "nodeId": 13052785,
    "price": 309.92,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "sscs3-pla-13052785-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "sscs3-pla-13053687-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "sscs3-pla-13053687-en-US",
    "name": {
      "en-US": "SimpliSafe Home Security System: 15 pieces",
      "en-GB": "SimpliSafe Home Security System: 15 pieces"
    },
    "nodeId": 13053687,
    "price": 534.86,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "sscs3-pla-13053687-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "SSCATM1-SS3-VZ",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": false,
    "masterSku": "SSCATM1-SS3-VZ",
    "name": {
      "en-US": "SS3-4G Module",
      "en-GB": "SS3-4G Module"
    },
    "nodeId": 4588210,
    "price": 0,
    "productTypeId": "1bc8cbc7-1316-4082-b772-f2736926ff2f",
    "restockDate": "1970-01-01",
    "sku": "SSCATM1-SS3-VZ",
    "variants": [],
    "productType": "accessory",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "bedford-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "bedford-en-US",
    "name": {
      "en-US": "Bedford",
      "en-GB": "Bedford"
    },
    "nodeId": 3487016,
    "price": 289.94,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "bedford-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "sscs3-pla-13055602-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "sscs3-pla-13055602-en-US",
    "name": {
      "en-US": "SimpliSafe Home Security System: 7 pieces",
      "en-GB": "SimpliSafe Home Security System: 7 pieces"
    },
    "nodeId": 13055602,
    "price": 284.94,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "sscs3-pla-13055602-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "sscs3-pla-13053347-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "sscs3-pla-13053347-en-US",
    "name": {
      "en-US": "SimpliSafe Home Security System: 11 pieces",
      "en-GB": "SimpliSafe Home Security System: 11 pieces"
    },
    "nodeId": 13053347,
    "price": 543.9,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "sscs3-pla-13053347-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "0",
    "id": "MI041",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "MI041",
    "name": {
      "en-US": "Smart Lock Series 2 Accessory Kit",
      "en-GB": "Smart Lock Series 2 Accessory Kit"
    },
    "nodeId": 18464477,
    "price": 0,
    "productTypeId": "1bc8cbc7-1316-4082-b772-f2736926ff2f",
    "restockDate": "1970-01-01",
    "sku": "MI041",
    "variants": [],
    "productType": "accessory",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "sscs3-pla-13055558-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "sscs3-pla-13055558-en-US",
    "name": {
      "en-US": "SimpliSafe Home Security System: 7 pieces",
      "en-GB": "SimpliSafe Home Security System: 7 pieces"
    },
    "nodeId": 13055558,
    "price": 309.93,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "sscs3-pla-13055558-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "sscs3-pla-13055679-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "sscs3-pla-13055679-en-US",
    "name": {
      "en-US": "SimpliSafe Home Security System: 7 pieces",
      "en-GB": "SimpliSafe Home Security System: 7 pieces"
    },
    "nodeId": 13055679,
    "price": 279.94,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "sscs3-pla-13055679-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "SSPP1",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSPP1",
    "name": {
      "en-US": "Pin Pad for Door Lock",
      "en-GB": "Pin Pad for Door Lock"
    },
    "nodeId": 5857888,
    "price": 29.99,
    "productTypeId": "1bc8cbc7-1316-4082-b772-f2736926ff2f",
    "restockDate": "1970-01-01",
    "sku": "SSPP1",
    "variants": [],
    "productType": "accessory",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "2",
    "id": "SSCATM1-SS2-VZ",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": false,
    "masterSku": "SSCATM1-SS2-VZ",
    "name": {
      "en-US": "SS2  Verizon CAT-M1 Module",
      "en-GB": "SS2  Verizon CAT-M1 Module"
    },
    "nodeId": 4588204,
    "price": 0,
    "productTypeId": "1bc8cbc7-1316-4082-b772-f2736926ff2f",
    "restockDate": "1970-01-01",
    "sku": "SSCATM1-SS2-VZ",
    "variants": [],
    "productType": "accessory",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "sscs3-pla-13055845-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "sscs3-pla-13055845-en-US",
    "name": {
      "en-US": "SimpliSafe Home Security System: 8 pieces",
      "en-GB": "SimpliSafe Home Security System: 8 pieces"
    },
    "nodeId": 13055845,
    "price": 378.94,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "sscs3-pla-13055845-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "sscs3-pla-13055746-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "sscs3-pla-13055746-en-US",
    "name": {
      "en-US": "SimpliSafe Home Security System: 8 pieces",
      "en-GB": "SimpliSafe Home Security System: 8 pieces"
    },
    "nodeId": 13055746,
    "price": 319.93,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "sscs3-pla-13055746-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "bunker-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "bunker-en-US",
    "name": {
      "en-US": "Bunker",
      "en-GB": "Bunker"
    },
    "nodeId": 3487100,
    "price": 344.91,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "bunker-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "SSLK1WW",
    "isCartable": false,
    "isIndeterminatePrice": false,
    "isOnStock": false,
    "isSellable": false,
    "isViewable": true,
    "masterSku": "SSLK1WW",
    "name": {
      "en-US": "Smartlock - White",
      "en-GB": "Smartlock - White"
    },
    "nodeId": 11425004,
    "price": 119.99,
    "productTypeId": "b7302816-bdaf-4b06-99fd-994f3622e8ca",
    "restockDate": "1970-01-01",
    "sku": "SSLK1WW",
    "variants": [],
    "productType": "sensor",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "nook-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "nook-en-US",
    "name": {
      "en-US": "Nook",
      "en-GB": "Nook"
    },
    "nodeId": 3486986,
    "price": 269.95,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "nook-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "SSLK1BB",
    "isCartable": false,
    "isIndeterminatePrice": false,
    "isOnStock": false,
    "isSellable": false,
    "isViewable": true,
    "masterSku": "SSLK1BB",
    "name": {
      "en-US": "Smartlock - Obsidian",
      "en-GB": "Smartlock - Obsidian"
    },
    "nodeId": 11425115,
    "price": 119.99,
    "productTypeId": "b7302816-bdaf-4b06-99fd-994f3622e8ca",
    "restockDate": "1970-01-01",
    "sku": "SSLK1BB",
    "variants": [],
    "productType": "sensor",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "total-protection-system-1-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "total-protection-system-1-en-US",
    "name": {
      "en-US": "Total Protection System",
      "en-GB": "Total Protection System"
    },
    "nodeId": 13042010,
    "price": 403.92,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "total-protection-system-1-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "CM006-01DWW-INC",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "CM006-01DWW-INC",
    "name": {
      "en-US": "Wireless Indoor Camera",
      "en-GB": "Wireless Indoor Camera"
    },
    "nodeId": 16493655,
    "price": 149.99,
    "productTypeId": "b7302816-bdaf-4b06-99fd-994f3622e8ca",
    "restockDate": "1970-01-01",
    "sku": "CM006-01DWW-INC",
    "variants": [],
    "productType": "sensor",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "",
    "id": "SSODMONON-SMB__18994692",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSODMONON-SMB__18994692",
    "name": {
      "en-US": "SMB Core (Monthly)",
      "en-GB": "SMB Core (Monthly)"
    },
    "nodeId": 18994692,
    "price": 49.99,
    "productTypeId": "e4a00ff7-f5f2-4efe-bd01-3237e4aec1c1",
    "restockDate": "",
    "sku": "SSODMONON-SMB__18994692",
    "variants": [],
    "productType": "service",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "sscs3-pla-13053558-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "sscs3-pla-13053558-en-US",
    "name": {
      "en-US": "SimpliSafe Home Security System: 13 pieces",
      "en-GB": "SimpliSafe Home Security System: 13 pieces"
    },
    "nodeId": 13053558,
    "price": 464.88,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "sscs3-pla-13053558-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "fortress-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "fortress-en-US",
    "name": {
      "en-US": "Fortress",
      "en-GB": "Fortress"
    },
    "nodeId": 3487324,
    "price": 524.86,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "fortress-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "0",
    "id": "GCDVP-INC",
    "isCartable": true,
    "isIndeterminatePrice": true,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "GCDVP-INC",
    "name": {
      "en-US": "$100 Visa Gift Card",
      "en-GB": "$100 Visa Gift Card"
    },
    "nodeId": 16894456,
    "price": 0,
    "productTypeId": "1bc8cbc7-1316-4082-b772-f2736926ff2f",
    "restockDate": "1970-01-01",
    "sku": "GCDVP-INC",
    "variants": [],
    "productType": "accessory",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "simplisafe-custom-home-security-system-refurbished-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "simplisafe-custom-home-security-system-refurbished-en-US",
    "name": {
      "en-US": "SimpliSafe Custom Home Security System (Refurbished)",
      "en-GB": "SimpliSafe Custom Home Security System (Refurbished)"
    },
    "nodeId": 19238170,
    "price": 0,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "simplisafe-custom-home-security-system-refurbished-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "CMOB1",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "CMOB1",
    "name": {
      "en-GB": "Outdoor Security Camera",
      "en-US": "Outdoor Security Camera"
    },
    "nodeId": 16489850,
    "price": 199.99,
    "productTypeId": "1bc8cbc7-1316-4082-b772-f2736926ff2f",
    "restockDate": "1970-01-01",
    "sku": "CMOB1",
    "variants": [],
    "productType": "accessory",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "sscs3-pla-13053647-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "sscs3-pla-13053647-en-US",
    "name": {
      "en-US": "SimpliSafe Home Security System: 13 pieces",
      "en-GB": "SimpliSafe Home Security System: 13 pieces"
    },
    "nodeId": 13053647,
    "price": 414.88,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "sscs3-pla-13053647-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "",
    "id": "SSSAPP-Y__97084",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSSAPP-Y__97084",
    "name": {
      "en-US": "Standard Monitoring - 1 Year",
      "en-GB": "Standard Monitoring - 1 Year"
    },
    "nodeId": 97084,
    "price": 252.89,
    "productTypeId": "e4a00ff7-f5f2-4efe-bd01-3237e4aec1c1",
    "restockDate": "",
    "sku": "SSSAPP-Y__97084",
    "variants": [],
    "productType": "service",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "restaurant-system-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "restaurant-system-en-US",
    "name": {
      "en-US": "Restaurant System",
      "en-GB": "Restaurant System"
    },
    "nodeId": 13041880,
    "price": 518.85,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "restaurant-system-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "lodge-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "lodge-en-US",
    "name": {
      "en-US": "Lodge",
      "en-GB": "Lodge"
    },
    "nodeId": 8597740,
    "price": 544.9,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "lodge-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "sscs3-pla-13052987-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "sscs3-pla-13052987-en-US",
    "name": {
      "en-US": "SimpliSafe Home Security System: 8 pieces",
      "en-GB": "SimpliSafe Home Security System: 8 pieces"
    },
    "nodeId": 13052987,
    "price": 294.93,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "sscs3-pla-13052987-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "sscs3-pla-13053856-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "sscs3-pla-13053856-en-US",
    "name": {
      "en-US": "SimpliSafe Home Security System: 21 pieces",
      "en-GB": "SimpliSafe Home Security System: 21 pieces"
    },
    "nodeId": 13053856,
    "price": 584.8,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "sscs3-pla-13053856-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "0",
    "id": "SSDBCC3",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSDBCC3",
    "name": {
      "en-US": "Doorbell Chime Connecter",
      "en-GB": "Doorbell Chime Connecter"
    },
    "nodeId": 4239874,
    "price": 0,
    "productTypeId": "1bc8cbc7-1316-4082-b772-f2736926ff2f",
    "restockDate": "1970-01-01",
    "sku": "SSDBCC3",
    "variants": [],
    "productType": "accessory",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "office-system-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "office-system-en-US",
    "name": {
      "en-US": "Office System",
      "en-GB": "Office System"
    },
    "nodeId": 13037991,
    "price": 418.89,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "office-system-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "SSBS3W",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSBS3W",
    "name": {
      "en-US": "Base Station",
      "en-GB": "Base Station"
    },
    "nodeId": 2198631,
    "price": 129.99,
    "productTypeId": "b6110ce0-7877-4a51-80e6-4335dc190cb7",
    "restockDate": "1970-01-01",
    "sku": "SSBS3W",
    "variants": [],
    "productType": "base-station",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "0",
    "id": "SSDB3",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSDB3",
    "name": {
      "en-US": "Wired Video Doorbell",
      "en-GB": "Wired Video Doorbell"
    },
    "nodeId": 4118430,
    "price": 169,
    "productTypeId": "b7302816-bdaf-4b06-99fd-994f3622e8ca",
    "restockDate": "1970-01-01",
    "sku": "SSDB3",
    "variants": [],
    "productType": "sensor",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "hub-starter-kit-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "hub-starter-kit-en-US",
    "name": {
      "en-US": "Hub Starter Kit",
      "en-GB": "Hub Starter Kit"
    },
    "nodeId": 16546221,
    "price": 439.93,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "hub-starter-kit-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "",
    "id": "SSEDSM2-Y__7344534",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSEDSM2-Y__7344534",
    "name": {
      "en-US": "Core Monitoring (Annual)",
      "en-GB": "Core Monitoring (Annual)"
    },
    "nodeId": 7344534,
    "price": 362.89,
    "productTypeId": "e4a00ff7-f5f2-4efe-bd01-3237e4aec1c1",
    "restockDate": "",
    "sku": "SSEDSM2-Y__7344534",
    "variants": [],
    "productType": "service",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "",
    "id": "SSEDSM2__4867366",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSEDSM2__4867366",
    "name": {
      "en-US": "Core Monitoring",
      "en-GB": "Core Monitoring"
    },
    "nodeId": 4867366,
    "price": 32.99,
    "productTypeId": "e4a00ff7-f5f2-4efe-bd01-3237e4aec1c1",
    "restockDate": "",
    "sku": "SSEDSM2__4867366",
    "variants": [],
    "productType": "service",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "2",
    "id": "SSWS1",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSWS1",
    "name": {
      "en-US": "105db Siren",
      "en-GB": "105db Siren"
    },
    "nodeId": 6382,
    "price": 59.99,
    "productTypeId": "b7302816-bdaf-4b06-99fd-994f3622e8ca",
    "restockDate": "1970-01-01",
    "sku": "SSWS1",
    "variants": [],
    "productType": "sensor",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "SSPA3W",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSPA3W",
    "name": {
      "en-US": "Power Adapter",
      "en-GB": "Power Adapter"
    },
    "nodeId": 3143506,
    "price": 5,
    "productTypeId": "1bc8cbc7-1316-4082-b772-f2736926ff2f",
    "restockDate": "1970-01-01",
    "sku": "SSPA3W",
    "variants": [],
    "productType": "accessory",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "",
    "id": "SSEDSM2__4638698",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSEDSM2__4638698",
    "name": {
      "en-US": "Core Monitoring - 6 Months Free!",
      "en-GB": "Core Monitoring - 6 Months Free!"
    },
    "nodeId": 4638698,
    "price": 32.99,
    "productTypeId": "e4a00ff7-f5f2-4efe-bd01-3237e4aec1c1",
    "restockDate": "",
    "sku": "SSEDSM2__4638698",
    "variants": [],
    "productType": "service",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "simplisafe-custom-home-security-system-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "simplisafe-custom-home-security-system-en-US",
    "name": {
      "en-US": "SimpliSafe Custom Home Security System",
      "en-GB": "SimpliSafe Custom Home Security System"
    },
    "nodeId": 19238075,
    "price": 0,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "simplisafe-custom-home-security-system-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "0",
    "id": "MI023",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "MI023",
    "name": {
      "en-US": "Window Decals",
      "en-GB": "Window Decals"
    },
    "nodeId": 16854982,
    "price": 1.99,
    "productTypeId": "1bc8cbc7-1316-4082-b772-f2736926ff2f",
    "restockDate": "1970-01-01",
    "sku": "MI023",
    "variants": [],
    "productType": "accessory",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "sscs3-pla-13053527-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "sscs3-pla-13053527-en-US",
    "name": {
      "en-US": "SimpliSafe Home Security System: 12 pieces",
      "en-GB": "SimpliSafe Home Security System: 12 pieces"
    },
    "nodeId": 13053527,
    "price": 354.89,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "sscs3-pla-13053527-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "stonehaven-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "stonehaven-en-US",
    "name": {
      "en-US": "Stonehaven",
      "en-GB": "Stonehaven"
    },
    "nodeId": 5482350,
    "price": 619,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "stonehaven-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "2",
    "id": "SSGB1",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSGB1",
    "name": {
      "en-US": "Glassbreak Sensor",
      "en-GB": "Glassbreak Sensor"
    },
    "nodeId": 736361,
    "price": 34.99,
    "productTypeId": "b7302816-bdaf-4b06-99fd-994f3622e8ca",
    "restockDate": "1970-01-01",
    "sku": "SSGB1",
    "variants": [],
    "productType": "sensor",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "SSWT3",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSWT3",
    "name": {
      "en-US": "Water Sensor",
      "en-GB": "Water Sensor"
    },
    "nodeId": 2198567,
    "price": 19.99,
    "productTypeId": "b7302816-bdaf-4b06-99fd-994f3622e8ca",
    "restockDate": "1970-01-01",
    "sku": "SSWT3",
    "variants": [],
    "productType": "sensor",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "sscs3-pla-13052935-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "sscs3-pla-13052935-en-US",
    "name": {
      "en-US": "SimpliSafe Home Security System: 9 pieces",
      "en-GB": "SimpliSafe Home Security System: 9 pieces"
    },
    "nodeId": 13052935,
    "price": 339.92,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "sscs3-pla-13052935-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "0",
    "id": "MAG-SLIM",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "MAG-SLIM",
    "name": {
      "en-US": "Magnet for Entry Sensor - Slim",
      "en-GB": "Magnet for Entry Sensor - Slim"
    },
    "nodeId": 337018,
    "price": 4.99,
    "productTypeId": "1bc8cbc7-1316-4082-b772-f2736926ff2f",
    "restockDate": "1970-01-01",
    "sku": "MAG-SLIM",
    "variants": [],
    "productType": "accessory",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "hearth-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "hearth-en-US",
    "name": {
      "en-US": "Hearth",
      "en-GB": "Hearth"
    },
    "nodeId": 16544374,
    "price": 409.91,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "hearth-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "0",
    "id": "smart-security-gift-kit-en-US",
    "isCartable": false,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": false,
    "isViewable": true,
    "masterSku": "smart-security-gift-kit-en-US",
    "name": {
      "en-US": "Smart Security Gift Kit",
      "en-GB": "Smart Security Gift Kit"
    },
    "nodeId": 7332720,
    "price": 507,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "smart-security-gift-kit-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "branch-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "branch-en-US",
    "name": {
      "en-US": "Branch",
      "en-GB": "Branch"
    },
    "nodeId": 13596351,
    "price": 454.92,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "branch-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "SSWS3",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSWS3",
    "name": {
      "en-US": "Wireless Siren",
      "en-GB": "Wireless Siren"
    },
    "nodeId": 2198599,
    "price": 59.99,
    "productTypeId": "b7302816-bdaf-4b06-99fd-994f3622e8ca",
    "restockDate": "1970-01-01",
    "sku": "SSWS3",
    "variants": [],
    "productType": "sensor",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "0",
    "id": "SSWFR3-TPAC750",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSWFR3-TPAC750",
    "name": {
      "en-US": "Wi-Fi Extender",
      "en-GB": "Wi-Fi Extender"
    },
    "nodeId": 4210366,
    "price": 24.99,
    "productTypeId": "1bc8cbc7-1316-4082-b772-f2736926ff2f",
    "restockDate": "1970-01-01",
    "sku": "SSWFR3-TPAC750",
    "variants": [],
    "productType": "accessory",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "SSGB3",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSGB3",
    "name": {
      "en-US": "Glassbreak Sensor",
      "en-GB": "Glassbreak Sensor"
    },
    "nodeId": 11465091,
    "price": 39.99,
    "productTypeId": "b7302816-bdaf-4b06-99fd-994f3622e8ca",
    "restockDate": "1970-01-01",
    "sku": "SSGB3",
    "variants": [],
    "productType": "sensor",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "sscs3-pla-13053827-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "sscs3-pla-13053827-en-US",
    "name": {
      "en-US": "SimpliSafe Home Security System: 16 pieces",
      "en-GB": "SimpliSafe Home Security System: 16 pieces"
    },
    "nodeId": 13053827,
    "price": 498.86,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "sscs3-pla-13053827-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "",
    "id": "SSSAPP-SMB__18993924",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSSAPP-SMB__18993924",
    "name": {
      "en-US": "SMB Standard (Monthly)",
      "en-GB": "SMB Standard (Monthly)"
    },
    "nodeId": 18993924,
    "price": 21.99,
    "productTypeId": "e4a00ff7-f5f2-4efe-bd01-3237e4aec1c1",
    "restockDate": "",
    "sku": "SSSAPP-SMB__18993924",
    "variants": [],
    "productType": "service",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "",
    "id": "SSSLFCAM__7453467",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSSLFCAM__7453467",
    "name": {
      "en-US": "Self Monitoring with Camera Recording",
      "en-GB": "Self Monitoring with Camera Recording"
    },
    "nodeId": 7453467,
    "price": 9.99,
    "productTypeId": "e4a00ff7-f5f2-4efe-bd01-3237e4aec1c1",
    "restockDate": "",
    "sku": "SSSLFCAM__7453467",
    "variants": [],
    "productType": "service",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "0",
    "id": "MI037",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "MI037",
    "name": {
      "en-US": "Outdoor Camera Power Cable",
      "en-GB": "Outdoor Camera Power Cable"
    },
    "nodeId": 18860954,
    "price": 29.99,
    "productTypeId": "1bc8cbc7-1316-4082-b772-f2736926ff2f",
    "restockDate": "1970-01-01",
    "sku": "MI037",
    "variants": [],
    "productType": "accessory",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "2",
    "id": "SSCS1-TRADE",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSCS1-TRADE",
    "name": {
      "en-US": "SimpliSafe Trade-In System",
      "en-GB": "SimpliSafe Trade-In System"
    },
    "nodeId": 58671,
    "price": -100,
    "productTypeId": "1bc8cbc7-1316-4082-b772-f2736926ff2f",
    "restockDate": "1970-01-01",
    "sku": "SSCS1-TRADE",
    "variants": [],
    "productType": "accessory",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "",
    "id": "SSODMONON__13798447",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSODMONON__13798447",
    "name": {
      "en-US": "Pro Monitoring",
      "en-GB": "Pro Monitoring"
    },
    "nodeId": 13798447,
    "price": 49.99,
    "productTypeId": "e4a00ff7-f5f2-4efe-bd01-3237e4aec1c1",
    "restockDate": "",
    "sku": "SSODMONON__13798447",
    "variants": [],
    "productType": "service",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "sanctuary-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "sanctuary-en-US",
    "name": {
      "en-US": "Sanctuary",
      "en-GB": "Sanctuary"
    },
    "nodeId": 3487074,
    "price": 319.91,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "sanctuary-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "0",
    "id": "GCVD2-INC",
    "isCartable": true,
    "isIndeterminatePrice": true,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "GCVD2-INC",
    "name": {
      "en-US": "$200 Visa Gift Card",
      "en-GB": "$200 Visa Gift Card"
    },
    "nodeId": 18225987,
    "price": 0,
    "productTypeId": "1bc8cbc7-1316-4082-b772-f2736926ff2f",
    "restockDate": "1970-01-01",
    "sku": "GCVD2-INC",
    "variants": [],
    "productType": "accessory",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "0",
    "id": "SSYS3",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSYS3",
    "name": {
      "en-US": "Home Security Yard Sign",
      "en-GB": "Home Security Yard Sign"
    },
    "nodeId": 5318,
    "price": 3.99,
    "productTypeId": "1bc8cbc7-1316-4082-b772-f2736926ff2f",
    "restockDate": "1970-01-01",
    "sku": "SSYS3",
    "variants": [],
    "productType": "accessory",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "0",
    "id": "SSCM2-INC",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSCM2-INC",
    "name": {
      "en-GB": "Wired Indoor Camera",
      "en-US": "Wired Indoor Camera"
    },
    "nodeId": 7395443,
    "price": 99,
    "productTypeId": "b7302816-bdaf-4b06-99fd-994f3622e8ca",
    "restockDate": "1970-01-01",
    "sku": "SSCM2-INC",
    "variants": [],
    "productType": "sensor",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "beacon-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "beacon-en-US",
    "name": {
      "en-US": "Beacon",
      "en-GB": "Beacon"
    },
    "nodeId": 16544197,
    "price": 729.9,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "beacon-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "0",
    "id": "MI038",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "MI038",
    "name": {
      "en-US": "25' Outdoor Power Cable",
      "en-GB": "25' Outdoor Power Cable"
    },
    "nodeId": 18861018,
    "price": 29.99,
    "productTypeId": "1bc8cbc7-1316-4082-b772-f2736926ff2f",
    "restockDate": "1970-01-01",
    "sku": "MI038",
    "variants": [],
    "productType": "accessory",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "SSCAM-BAT1",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSCAM-BAT1",
    "name": {
      "en-US": "Outdoor Camera Battery",
      "en-GB": "Outdoor Camera Battery"
    },
    "nodeId": 7940057,
    "price": 29.99,
    "productTypeId": "1bc8cbc7-1316-4082-b772-f2736926ff2f",
    "restockDate": "1970-01-01",
    "sku": "SSCAM-BAT1",
    "variants": [],
    "productType": "accessory",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "simplisafe-customer-upgrade-system-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "simplisafe-customer-upgrade-system-en-US",
    "name": {
      "en-US": "SimpliSafe Customer Upgrade System",
      "en-GB": "SimpliSafe Customer Upgrade System"
    },
    "nodeId": 19238113,
    "price": 0,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "simplisafe-customer-upgrade-system-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "keep-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "keep-en-US",
    "name": {
      "en-US": "Keep",
      "en-GB": "Keep"
    },
    "nodeId": 7405019,
    "price": 458.9,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "keep-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "0",
    "id": "MI039",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": false,
    "masterSku": "MI039",
    "name": {
      "en-GB": "Installation Hardware",
      "en-US": "Installation Hardware"
    },
    "nodeId": 18936825,
    "price": 0,
    "productTypeId": "1bc8cbc7-1316-4082-b772-f2736926ff2f",
    "restockDate": "1970-01-01",
    "sku": "MI039",
    "variants": [],
    "productType": "accessory",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "haven-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "haven-en-US",
    "name": {
      "en-US": "Haven",
      "en-GB": "Haven"
    },
    "nodeId": 16544307,
    "price": 529.86,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "haven-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "CA002-01DWW-INC",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "CA002-01DWW-INC",
    "name": {
      "en-US": "Smoke & CO Detector",
      "en-GB": "Smoke & CO Detector"
    },
    "nodeId": 16544273,
    "price": 69.99,
    "productTypeId": "b7302816-bdaf-4b06-99fd-994f3622e8ca",
    "restockDate": "1970-01-01",
    "sku": "CA002-01DWW-INC",
    "variants": [],
    "productType": "sensor",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "CM021-01DWW",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "CM021-01DWW",
    "name": {
      "en-US": "Outdoor Security Camera Series 2",
      "en-GB": "Outdoor Security Camera Series 2"
    },
    "nodeId": 16623637,
    "price": 199.99,
    "productTypeId": "b7302816-bdaf-4b06-99fd-994f3622e8ca",
    "restockDate": "1970-01-01",
    "sku": "CM021-01DWW",
    "variants": [],
    "productType": "sensor",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "",
    "id": "SSEDSM2-SMB__18994653",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSEDSM2-SMB__18994653",
    "name": {
      "en-US": "Core Business (Monthly)",
      "en-GB": "Core Business (Monthly)"
    },
    "nodeId": 18994653,
    "price": 31.99,
    "productTypeId": "e4a00ff7-f5f2-4efe-bd01-3237e4aec1c1",
    "restockDate": "",
    "sku": "SSEDSM2-SMB__18994653",
    "variants": [],
    "productType": "service",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "",
    "id": "SSODMON247__16723550",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSODMON247__16723550",
    "name": {
      "en-US": "Pro Plus Monitoring - 60 Days Free",
      "en-GB": "Pro Plus Monitoring - 60 Days Free"
    },
    "nodeId": 16723550,
    "price": 79.99,
    "productTypeId": "e4a00ff7-f5f2-4efe-bd01-3237e4aec1c1",
    "restockDate": "",
    "sku": "SSODMON247__16723550",
    "variants": [],
    "productType": "service",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "boston-small-business-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "boston-small-business-en-US",
    "name": {
      "en-US": "Boston Small Business",
      "en-GB": "Boston Small Business"
    },
    "nodeId": 7344832,
    "price": 424.87,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "boston-small-business-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "home-protection-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "home-protection-en-US",
    "name": {
      "en-US": "Home Protection",
      "en-GB": "Home Protection"
    },
    "nodeId": 17599109,
    "price": 484.93,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "home-protection-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "",
    "id": "SSEDSM2__1964913",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSEDSM2__1964913",
    "name": {
      "en-US": "24/7 Interactive Alarm Monitoring + Alerts",
      "en-GB": "24/7 Interactive Alarm Monitoring + Alerts"
    },
    "nodeId": 1964913,
    "price": 32.99,
    "productTypeId": "e4a00ff7-f5f2-4efe-bd01-3237e4aec1c1",
    "restockDate": "",
    "sku": "SSEDSM2__1964913",
    "variants": [],
    "productType": "service",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "",
    "id": "SSEDSM2__61044",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSEDSM2__61044",
    "name": {
      "en-US": "24/7 Professional Alarm Monitoring",
      "en-GB": "24/7 Professional Alarm Monitoring"
    },
    "nodeId": 61044,
    "price": 32.99,
    "productTypeId": "e4a00ff7-f5f2-4efe-bd01-3237e4aec1c1",
    "restockDate": "",
    "sku": "SSEDSM2__61044",
    "variants": [],
    "productType": "service",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "0",
    "id": "SSSDD-D2D",
    "isCartable": true,
    "isIndeterminatePrice": true,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSSDD-D2D",
    "name": {
      "en-US": "SimpliSafe Instant Delivery (Kit)",
      "en-GB": "SimpliSafe Instant Delivery (Kit)"
    },
    "nodeId": 18152994,
    "price": 0,
    "productTypeId": "1bc8cbc7-1316-4082-b772-f2736926ff2f",
    "restockDate": "1970-01-01",
    "sku": "SSSDD-D2D",
    "variants": [],
    "productType": "accessory",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "",
    "id": "SSODMONON__16723548",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSODMONON__16723548",
    "name": {
      "en-US": "Pro Monitoring - 60 Days Free",
      "en-GB": "Pro Monitoring - 60 Days Free"
    },
    "nodeId": 16723548,
    "price": 49.99,
    "productTypeId": "e4a00ff7-f5f2-4efe-bd01-3237e4aec1c1",
    "restockDate": "",
    "sku": "SSODMONON__16723548",
    "variants": [],
    "productType": "service",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "large-non-insurance-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "large-non-insurance-en-US",
    "name": {
      "en-US": "Whole Home Kit - N",
      "en-GB": "Whole Home Kit - N"
    },
    "nodeId": 16546131,
    "price": 539.88,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "large-non-insurance-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "",
    "id": "SSEDSM2__5475168",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSEDSM2__5475168",
    "name": {
      "en-US": "Pro Superior Monitoring",
      "en-GB": "Pro Superior Monitoring"
    },
    "nodeId": 5475168,
    "price": 32.99,
    "productTypeId": "e4a00ff7-f5f2-4efe-bd01-3237e4aec1c1",
    "restockDate": "",
    "sku": "SSEDSM2__5475168",
    "variants": [],
    "productType": "service",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "CM015-02DUS",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "CM015-02DUS",
    "name": {
      "en-US": "Audio Enhancer",
      "en-GB": "Audio Enhancer"
    },
    "nodeId": 15740388,
    "price": 0,
    "productTypeId": "1bc8cbc7-1316-4082-b772-f2736926ff2f",
    "restockDate": "1970-01-01",
    "sku": "CM015-02DUS",
    "variants": [],
    "productType": "accessory",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "large-insurance-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "large-insurance-en-US",
    "name": {
      "en-US": "Whole Home Kit - I",
      "en-GB": "Whole Home Kit - I"
    },
    "nodeId": 16545047,
    "price": 584.88,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "large-insurance-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "hub-whole-kit-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "hub-whole-kit-en-US",
    "name": {
      "en-US": "Hub Whole Kit",
      "en-GB": "Hub Whole Kit"
    },
    "nodeId": 16546255,
    "price": 714.88,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "hub-whole-kit-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "",
    "id": "SSODMON247__13798553",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSODMON247__13798553",
    "name": {
      "en-US": "Pro Plus Monitoring",
      "en-GB": "Pro Plus Monitoring"
    },
    "nodeId": 13798553,
    "price": 79.99,
    "productTypeId": "e4a00ff7-f5f2-4efe-bd01-3237e4aec1c1",
    "restockDate": "",
    "sku": "SSODMON247__13798553",
    "variants": [],
    "productType": "service",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "",
    "id": "SSEDSM2__4873424",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSEDSM2__4873424",
    "name": {
      "en-US": "Interactive Alarm Monitoring",
      "en-GB": "Interactive Alarm Monitoring"
    },
    "nodeId": 4873424,
    "price": 32.99,
    "productTypeId": "e4a00ff7-f5f2-4efe-bd01-3237e4aec1c1",
    "restockDate": "",
    "sku": "SSEDSM2__4873424",
    "variants": [],
    "productType": "service",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "homestead-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "homestead-en-US",
    "name": {
      "en-US": "Homestead",
      "en-GB": "Homestead"
    },
    "nodeId": 3487052,
    "price": 299.93,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "homestead-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "",
    "id": "SSEDSM2__5475158",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSEDSM2__5475158",
    "name": {
      "en-US": "Pro Superior Monitoring",
      "en-GB": "Pro Superior Monitoring"
    },
    "nodeId": 5475158,
    "price": 32.99,
    "productTypeId": "e4a00ff7-f5f2-4efe-bd01-3237e4aec1c1",
    "restockDate": "",
    "sku": "SSEDSM2__5475158",
    "variants": [],
    "productType": "service",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "0",
    "id": "SSDBFP-BRIGHT",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": false,
    "masterSku": "SSDBFP-BRIGHT",
    "name": {
      "en-US": "Bright Doorbell Faceplate",
      "en-GB": "Bright Doorbell Faceplate"
    },
    "nodeId": 6213174,
    "price": 0,
    "productTypeId": "1bc8cbc7-1316-4082-b772-f2736926ff2f",
    "restockDate": "1970-01-01",
    "sku": "SSDBFP-BRIGHT",
    "variants": [],
    "productType": "accessory",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "2",
    "id": "SSPB1",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "SSPB1",
    "name": {
      "en-US": "Panic Button",
      "en-GB": "Panic Button"
    },
    "nodeId": 736368,
    "price": 19.99,
    "productTypeId": "b7302816-bdaf-4b06-99fd-994f3622e8ca",
    "restockDate": "1970-01-01",
    "sku": "SSPB1",
    "variants": [],
    "productType": "sensor",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "lighthouse-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "lighthouse-en-US",
    "name": {
      "en-US": "Lighthouse",
      "en-GB": "Lighthouse"
    },
    "nodeId": 16544439,
    "price": 479.93,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "lighthouse-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "CMCBL1-INC",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "CMCBL1-INC",
    "name": {
      "en-US": "Outdoor Camera Power Cable",
      "en-GB": "Outdoor Camera Power Cable"
    },
    "nodeId": 17337325,
    "price": 29.99,
    "productTypeId": "1bc8cbc7-1316-4082-b772-f2736926ff2f",
    "restockDate": "1970-01-01",
    "sku": "CMCBL1-INC",
    "variants": [],
    "productType": "accessory",
    "_xtype": "product"
  },
  {
    "@@type": "product",
    "hardwareVersion": "3",
    "id": "business-essentials-system-en-US",
    "isCartable": true,
    "isIndeterminatePrice": false,
    "isOnStock": true,
    "isSellable": true,
    "isViewable": true,
    "masterSku": "business-essentials-system-en-US",
    "name": {
      "en-US": "Business Essentials System",
      "en-GB": "Business Essentials System"
    },
    "nodeId": 13041946,
    "price": 279.95,
    "productTypeId": "89c3c8fe-7b9a-4c1c-8c8a-36805d4a0368",
    "restockDate": "",
    "sku": "business-essentials-system-en-US",
    "variants": [],
    "productType": "package_parent",
    "_xtype": "product"
  }
]